import firebase from 'firebase'

const firebaseConfig = {
  apiKey: 'AIzaSyAvjscrjduMiw47unGjRwVmgzLe9LbkHBc',
  authDomain: 'etas-file.firebaseapp.com',
  databaseURL: 'https://etas-file.firebaseio.com',
  projectId: 'etas-file',
  storageBucket: '',
  messagingSenderId: '233812663930',
  appId: '1:233812663930:web:ba1c33c47217ee94'
}

firebase.initializeApp(firebaseConfig)

export default (Vue) => {
  Vue.prototype.$firebase = firebase
}
